<template>
  <section class="sl-list-section" :class="{'is-basket': isBasket}">
    <header>
      <div class="icon"><fa-icon :icon="icon"></fa-icon></div>
      <div class="name">{{ label }}</div>
      <div class="total" v-if="!isBusy"><amt-cents :cents="totalCents" :is-estimate="hasItemsWithoutPrice" v-if="totalCents" /></div>
    </header>
    <div class="loading loading-xl" v-if="isBusy"></div>
    <div class="sl-categories" v-if="!isBusy">
      <template v-if="categorySections.length">
      <category-items v-for="section in categorySections" :key="section.category.id"
                      :category="section.category" :category-items="section.items" :is-in-basket="isBasket" />
      </template>
      <template v-else>
        <div class="empty bg-dark">
          <div class="empty-icon text-primary">
            <fa-icon :icon="icon" size="4x"></fa-icon>
          </div>
          <div class="empty-subtitle text-gray">Nothing {{ label.toLowerCase() }} yet...</div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ListSection',
  props: {
    label: { type: String, required: true },
    icon: { type: String, required: true },
    isBasket: { type: Boolean, required: false },
    sectionItems: { type: Array, required: true },
    isBusy: { type: Boolean, required: false }
  },
  computed: {
    categorySections () {
      const catSections = []
      const catMap = _.groupBy(this.sectionItems, 'categoryId')
      _.forOwn(catMap, (items, catIdStr) => {
        const category = this.getCategoryForId(catIdStr)
        catSections.push({ category, items: _.sortBy(items, i => i.name.toLowerCase()) })
      })
      return _.sortBy(catSections, c => c.category.name.toLowerCase())
    },
    hasItemsWithoutPrice () {
      return _.some(this.sectionItems, i => i.hasNoPrice)
    },
    totalCents () {
      return _.reduce(this.sectionItems, (total, i) => {
        return total + i.totalPriceCents
      }, 0)
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  .sl-list-section {
    margin-bottom: 2rem;

    > header {
      display: flex;
      align-items: center;
      font-size: 1.33rem;
      font-weight: normal;
      margin-bottom: 0.25rem;
      width: 100%;

      .icon {
        flex: 0 0 2rem;
        text-align: center;
      }

      .name {
        flex: 1 0 auto;
      }

      .total {
        flex: 0 0 4rem;
        text-align: right;
        padding-right: 0.25rem;
      }
    }

    &.is-basket {
      border-top: 1px solid lighten($dark-color, 10%);
      padding-top: 1rem;

      > header {
        color: lighten($dark-color, 35%);
      }
    }

    .sl-category-item-list {
    }
  }
</style>
